import AdminContact from './AdminContact';

export default AdminContact;
